module.exports = __webpack_public_path__ + "static/media/12.8983589e.png";